import { DivisionMileStone } from "../../api/divisionMileStones/types";

export interface MilestoneFilterDropdownProps {
  milestones?: DivisionMileStone[];
  setSelectedMilestoneType?: (value: string) => void;
  setGetParams: (params: any) => void;
  getParams: any;
  buyerlistingData?: any;
  milestoneSpecificCounts?: { [key: string]: { exceptionCount: number, alertsCount: number, notesCount: number, generalCommentsCount: number } };
}

export interface IMilestoneDropdownOption {
  label: string | JSX.Element;
  value: string;
  exceptionCount?: number;
  alertsCount?: number;
  notesCount?: number;
  generalCommentsCount?: number;
  milestone?: DivisionMileStone | null;
}

export const MILESTONE_FILTER_PARAMS = {
  milestone: "milestone",
};

export const MILESTONE_FILTER_VALUES = {
  allMilestones: "allMilestones",
}; 